import { app } from '../../../app';
import { Controller } from './sms-services.controller';

app.component('companySmsServices', {
    bindings: {
        companyId: '<',
        purchaseHistory: '<',
        settings: '<',
    },
    controller: Controller,
    templateUrl: require('./sms-services.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/sms-services.component.js